import React from 'react';

const ProjectTwoDetails = () => {
    return (
        <div>
            
        </div>
    );
};

export default ProjectTwoDetails;